const EMPTY_DEFECT_LABELS = new Set([
  '',
  '-',
  'n/a',
  'na',
  'none',
  'safe',
  'no defect',
  'no defects',
  'no defect observed',
  'no defects observed',
  'no defect has been observed',
  'unknown',
  'unknown defect',
]);

const getDefectLabel = (defect) => {
  if (typeof defect === 'string') return defect;
  if (!defect || typeof defect !== 'object') return '';
  return (
    defect.defect_type ||
    defect.defectType ||
    defect.type ||
    defect.text ||
    defect.name ||
    defect.description ||
    ''
  );
};

const hasDefectBox = (defect) => {
  if (!defect || typeof defect !== 'object') return false;
  const width = Number(defect.width ?? defect.w ?? 0);
  const height = Number(defect.height ?? defect.h ?? 0);
  return Number.isFinite(width) && Number.isFinite(height) && width > 0 && height > 0;
};

export const isMeaningfulDefect = (defect) => {
  const label = String(getDefectLabel(defect) || '').trim();
  const normalized = label.toLowerCase();

  if (EMPTY_DEFECT_LABELS.has(normalized)) return false;
  if (normalized === 'general defect' && !hasDefectBox(defect)) return false;
  if (label) return true;

  return hasDefectBox(defect);
};

export const hasMeaningfulDefects = (defects) => (
  Array.isArray(defects) && defects.some(isMeaningfulDefect)
);
